module.exports = __webpack_public_path__ + "static/media/ned_logo.902c80f1.png";